import apiClient from './apiClient';
import { ChangePasswordDto, ApiMessageResponse } from '../types/changePassword';

export const changePassword = async (data: ChangePasswordDto): Promise<ApiMessageResponse> => {
  const response = await apiClient.post('/ChangePassword', data);
  return response as unknown as ApiMessageResponse;
};